export default __webpack_public_path__ + "src/images/sections/f1b7d158a18092943f808a444bec7e1d-unleash_your_paradise.jpg";